import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://marmolescolaiacovo.com.ar';
const DEFAULT_DESCRIPTION = 'Empresa líder con más de 60 años de experiencia en mármoles, granitos y cuarzos. Atención personalizada e instalación profesional en Flores, Buenos Aires.';
const DEFAULT_IMAGE = `${BASE_URL}/logo_small.jfif`;

export default function SeoHead({ title, description = DEFAULT_DESCRIPTION, path = '', image = DEFAULT_IMAGE }) {
  const fullTitle = title
    ? `${title} | Marmolería Colaiacovo`
    : 'Marmolería Colaiacovo: El apellido del mármol - Capital Federal, Flores';
  const canonical = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
